import UserForm from "@components/forms/UserForm/UserForm";
import Spacing from "@vfuk/core-spacing/";
import manageAccessBanner from "@img/manageAccessBanner.png";
import { useTranslation } from "react-i18next";
import { SectionBanner, Crumbs } from "@ucchub/ui";
import DashShell from "@components/common/DashShell";
import { Grid, GridColumn, GridRow } from "@vfuk/core-grid";
import breadCrumbs from "@json/common/crumbs.json";

const AddUser = () => {
  const { t } = useTranslation();

  return (
    <DashShell>
      <Crumbs items={breadCrumbs.add_Users} />
      <SectionBanner
        heading={t("shared:users:add_users_banner.heading")}
        subtitle={
          t("shared:users:add_users_banner.sub_title") ||
          "Create a new user and add them to this portal"
        }
        image={manageAccessBanner}
        iconName="add-friend"
      />
      <div className="addUserBG">
        <Grid maxWidth="spring">
          <Spacing
            spacingLevel={{
              top: 4,
              bottom: 4,
            }}
          >
            <GridRow justify="center">
              <GridColumn col={12} colMd={8} colLg={6}>
                <UserForm />
              </GridColumn>
            </GridRow>
          </Spacing>
        </Grid>
      </div>
    </DashShell>
  );
};

export default AddUser;
